/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Port
 */
export interface Port {
}

/**
 * Check if a given object implements the Port interface.
 */
export function instanceOfPort(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PortFromJSON(json: any): Port {
    return PortFromJSONTyped(json, false);
}

export function PortFromJSONTyped(json: any, ignoreDiscriminator: boolean): Port {
    return json;
}

export function PortToJSON(value?: Port | null): any {
    return value;
}

